import { DatabaseZap, Lock, RefreshCw, WifiOff } from "lucide-react";

import { ErrorApi } from "../api/cliente.ts";
import { Aviso, Boton, Esqueleto, Tarjeta, Vacio } from "./ui.tsx";

/**
 * Un fallo tiene que decir qué pasó y qué hacer. "Error inesperado" no es
 * ninguna de las dos cosas.
 */
export function ErrorConsulta({ error, alReintentar }: { error: unknown; alReintentar?: () => void }) {
  if (error instanceof ErrorApi && error.esSinPermiso) {
    return (
      <Tarjeta>
        <Vacio icono={Lock} titulo="Esta parte no es para tu rol">
          {error.message} Si crees que deberías verla, pídeselo a quien administra la cuenta.
        </Vacio>
      </Tarjeta>
    );
  }

  if (error instanceof ErrorApi && error.esDatosRotos) {
    return (
      <Aviso tono="peligro" titulo="4drando no pudo leer los datos que le llegaron" icono={DatabaseZap}>
        <p>{error.message}</p>
        <p className="mt-1">
          4drando prefiere no mostrar nada a mostrarte pagos armados sobre datos que no entiende.
          Corrige el origen y vuelve a intentar.
        </p>
        {alReintentar && (
          <Boton variante="suave" tamano="sm" icono={RefreshCw} className="mt-3" onClick={alReintentar}>
            Reintentar
          </Boton>
        )}
      </Aviso>
    );
  }

  const mensaje =
    error instanceof ErrorApi ? error.message : "No se pudo hablar con 4drando. Revisa tu conexión.";

  return (
    <Aviso tono="peligro" titulo="Algo salió mal" icono={WifiOff}>
      <p>{mensaje}</p>
      {alReintentar && (
        <Boton variante="suave" tamano="sm" icono={RefreshCw} className="mt-3" onClick={alReintentar}>
          Reintentar
        </Boton>
      )}
    </Aviso>
  );
}

/** Esqueleto con la forma de lo que viene: menos salto al llegar los datos. */
export const EsqueletoLista = ({ filas = 3 }: { filas?: number }) => (
  <div className="space-y-3">
    {Array.from({ length: filas }, (_, i) => (
      <Tarjeta key={i} className="space-y-4 p-5">
        <div className="flex justify-between gap-4">
          <div className="space-y-2">
            <Esqueleto className="h-3 w-24" />
            <Esqueleto className="h-8 w-40" />
            <Esqueleto className="h-3 w-56" />
          </div>
          <Esqueleto className="h-6 w-28 rounded-full" />
        </div>
        <Esqueleto className="h-16 w-full" />
      </Tarjeta>
    ))}
  </div>
);

export const EsqueletoTabla = ({ filas = 6 }: { filas?: number }) => (
  <div className="space-y-2">
    {Array.from({ length: filas }, (_, i) => (
      <Esqueleto key={i} className="h-12 w-full" />
    ))}
  </div>
);
